import type { components } from '@social-studio/operator-client';
import { useQuery } from '@tanstack/react-query';
import { api, call } from '../../lib/api';

export type OperatorOverview = components['schemas']['OperatorOverviewDto'];

export function useOverview() {
  return useQuery({ queryKey: ['operator-overview'], queryFn: () => call(() => api.GET('/v1/operator/overview')) });
}
